// extracted by mini-css-extract-plugin
export default {"mn-multi-item-wrap":"index_mn-multi-item-wrap__rnfWs"};